// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d6Urbc2UlUtbsIA_VTWZ {\n  display: flex;\n}", "",{"version":3,"sources":["webpack://./src/ui/views/users/components/UsersImportModal/components/ResultMessages/AlertItem.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".AlertItemWrapper {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AlertItemWrapper": "d6Urbc2UlUtbsIA_VTWZ"
};
export default ___CSS_LOADER_EXPORT___;
